// Review F3-4: "Send invitation" for one authorised guest-list uploader (the Module 9 portal-invite email, unlocking only that grant).
// Kept in this tiny module on purpose: it is the only outside-door call in the Events foundation screens, so the Breaker Panel
// baseline exempts this file alone. The door itself is checked server-side: portal-invite runs breakerDoorCheck (Events, D2).
// One click = one request id = at most one email; a retry of the same click is the same request.
// Review 2 (N1): the server answers a client with the same neutral message whether or not the email already had a login.
export async function inviteUploader(client, grantId, requestId) {
    const { data, error } = await client.functions.invoke('portal-invite', { body: { action: 'event_upload', grantId, requestId } });
    if (error) {
        const details = typeof Response !== 'undefined' && error.context instanceof Response ? await error.context.json().catch(() => null) : null;
        throw new Error(details?.error || error.message || 'The invitation could not be sent.');
    }
    if (data?.error) throw new Error(data.error);
    return data || {};
}
